var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8445 9.98954C16.8445 12.3196 16.7081 14.4439 16.5025 15.8287C16.4993 15.8322 16.4914 15.8668 16.4795 15.925L16.4 16.3218C16.2971 16.8284 16.1298 17.5895 15.9533 17.9303C15.4506 18.9 14.4678 19.5 13.4159 19.5H13.3244C12.6387 19.4773 11.1981 18.8756 11.1981 18.8547C8.77481 17.8379 3.99723 14.6759 2.07653 12.5743L2.00551 12.5023C1.85066 12.344 1.48197 11.9588 1.29926 11.697C0.933088 11.2121 0.75 10.6122 0.75 10.0122C0.75 9.34248 0.955544 8.71985 1.34418 8.21058C1.43572 8.11814 1.77771 7.72747 2.09898 7.40307C3.97305 5.37121 8.86636 2.04874 11.4261 1.03194C11.8148 0.869745 12.7976 0.524417 13.3244 0.5C13.827 0.5 14.3072 0.616853 14.7649 0.847072C15.3366 1.16973 15.7926 1.679 16.0448 2.27896C16.2054 2.69405 16.4576 3.94107 16.4576 3.96374C16.7081 5.32587 16.8445 7.54085 16.8445 9.98954ZM29.25 10.0007C29.25 11.3279 28.1843 12.404 26.8698 12.404L21.0127 11.886C19.9816 11.886 19.1456 11.0419 19.1456 10.0007C19.1456 8.95774 19.9816 8.11535 21.0127 8.11535L26.8698 7.59736C28.1843 7.59736 29.25 8.67345 29.25 10.0007Z",
    fill: "#010CA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.5feb5e574fabde12768d54598e56ab64.svg";
export { ForwardRef as ReactComponent };